/**
 * Centralized Branch to Shopify Location Mapping Configuration
 * Maps branch identifiers (store names, branch handles) to Shopify Location IDs.
 * Location IDs can be configured here or loaded dynamically from Metaobjects.
 */
(function() {
  window.BRANCH_LOCATIONS = window.BRANCH_LOCATIONS || {
    "Salmiya": {
      name: "Al Salmiya Pharmacy (Salmiya)",
      name_ar: "",
      locationId: "100301734135"
    },
    "Al Baraka Pharmacy (Jeleep)": {
      name: "Al Baraka Pharmacy (Jeleep)",
      name_ar: "",
      locationId: "95572426937"
    },
    "Jeleeb Pharmacy (Jeleep)": {
      name: "Jeleeb Pharmacy (Jeleep)",
      name_ar: "",
      locationId: "95572426937"
    },
    "Jeleeb": {
      name: "Jeleeb Pharmacy (Jeleep)",
      name_ar: "",
      locationId: "95572426937"
    },
    "Jeleep": {
      name: "Al Baraka Pharmacy (Jeleep)",
      name_ar: "",
      locationId: "95572426937"
    }
  };

  /**
   * Helper function to get branch configuration by name or identifier
   * @param {string} identifier - Branch name, ID, or handle
   * @returns {Object|null} Branch config object
   */
  window.getBranchConfig = function(identifier) {
    if (!identifier) return null;
    const cleanId = String(identifier).trim();
    if (window.BRANCH_LOCATIONS[cleanId]) {
      return window.BRANCH_LOCATIONS[cleanId];
    }
    // Case-insensitive / normalized lookup
    const lowerId = cleanId.toLowerCase();
    for (const key in window.BRANCH_LOCATIONS) {
      if (key.toLowerCase() === lowerId ||
          (window.BRANCH_LOCATIONS[key].name && window.BRANCH_LOCATIONS[key].name.toLowerCase() === lowerId) ||
          (window.BRANCH_LOCATIONS[key].name_ar && window.BRANCH_LOCATIONS[key].name_ar.toLowerCase() === lowerId)) {
        return window.BRANCH_LOCATIONS[key];
      }
    }

    // Fuzzy / token matching (e.g. Jeleeb vs Jeleep, removing pharmacy prefixes)
    const normalize = s => String(s || '').toLowerCase()
      .replace(/al\s+/g, '')
      .replace(/pharmacy/g, '')
      .replace(/صيدلية/g, '')
      .replace(/فرع/g, '')
      .replace(/[^a-z0-9\u0600-\u06FF]/g, ' ')
      .trim();
    const idTokens = normalize(cleanId).split(/\s+/).filter(w => w.length > 2);

    if (idTokens.length > 0) {
      for (const key in window.BRANCH_LOCATIONS) {
        const entry = window.BRANCH_LOCATIONS[key];
        const targetStrings = [key, entry.name, entry.name_ar].filter(Boolean);
        for (const tStr of targetStrings) {
          const tTokens = normalize(tStr).split(/\s+/).filter(w => w.length > 2);
          const match = idTokens.some(it => tTokens.some(tt => {
            if (it === tt || it.includes(tt) || tt.includes(it)) return true;
            return it.replace(/b/g, 'p') === tt.replace(/b/g, 'p');
          }));
          if (match) return entry;
        }
      }
    }

    // Fallback object if not mapped
    return {
      name: cleanId,
      name_ar: cleanId,
      locationId: cleanId
    };
  };

  /**
   * Get Shopify Location ID for a given branch
   * @param {string} identifier 
   * @returns {string} Shopify Location ID
   */
  window.getLocationIdForBranch = function(identifier) {
    const config = window.getBranchConfig(identifier);
    return config ? config.locationId : '';
  };
})();
